<template>
	<div
		class="flex snap-x snap-mandatory gap-8 overflow-hidden overflow-x-scroll hide-scrollbars pt-3 pb-8 px-[35vw] sm:px-12 lg:grid lg:gap-12 lg:overflow-visible lg:py-0 lg:px-0 grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
	>
		<slot />
	</div>
</template>
